const CHUNK_RELOAD_KEY = "chunk-reload-attempted";

export const isChunkLoadError = (error: unknown) => {
  if (!error) {
    return false;
  }

  const maybeError = error as { message?: string; name?: string };
  const message = String(maybeError.message ?? error).toLowerCase();
  const name = String(maybeError.name ?? "").toLowerCase();

  return (
    message.includes("loading chunk failed") ||
    message.includes("loading chunk") ||
    message.includes("chunkloaderror") ||
    message.includes("failed to fetch dynamically imported module") ||
    name.includes("chunkloaderror")
  );
};

export const lazyRetry = <T>(
  importer: () => Promise<{ default: T }>,
): Promise<{ default: T }> =>
  new Promise((resolve, reject) => {
    importer()
      .then((module) => {
        sessionStorage.removeItem(CHUNK_RELOAD_KEY);
        resolve(module);
      })
      .catch((error: unknown) => {
        if (isChunkLoadError(error)) {
          const hasReloaded =
            sessionStorage.getItem(CHUNK_RELOAD_KEY) === "true";

          if (!hasReloaded) {
            sessionStorage.setItem(CHUNK_RELOAD_KEY, "true");
            window.location.reload();
            return;
          }
        }

        reject(error);
      });
  });

export const clearChunkReloadState = () => {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
};

export { CHUNK_RELOAD_KEY };
